

const Admission = () => {
  return (
    <div className="min-h-screen py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">Admission Process</h1>
        
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-6">Admission Requirements</h2>
          
          <div className="prose max-w-none">
            <h3 className="text-xl font-medium text-gray-700 mb-3">For New Students</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Completed application form</li>
              <li>Birth certificate or proof of age</li>
              <li>Previous academic transcripts</li>
              <li>Two passport-size photographs</li>
              <li>Medical fitness certificate</li>
              <li>Parent/Guardian identification</li>
            </ul>
            
            <h3 className="text-xl font-medium text-gray-700 mb-3">Transfer Students</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>All requirements for new students</li>
              <li>Transfer certificate from previous school</li>
              <li>Conduct certificate</li>
              <li>Proof of residence</li>
            </ul>
            
            <h3 className="text-xl font-medium text-gray-700 mb-3">Fee Structure</h3>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Class</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Admission Fee</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Annual Fee</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Monthly Fee</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Nursery</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$50</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$800</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$60</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">KG</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$50</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$850</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$65</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Grade 1-5</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$75</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$900</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$70</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Grade 6-10</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$100</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$1100</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$85</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Grade 11-12</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$125</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$1300</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">$100</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div className="mt-8 text-center">
              <a 
                href="/admission/form" 
                className="inline-block bg-primary text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
              >
                Apply Online
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admission;